module.exports = __webpack_public_path__ + "img/choose-up-Up Cresa-disabled.4bcd9409.png";